/**
 * FloatingChatButton – Fixed-position chat help button.
 * Figma: white circle with drop shadow containing navy speech bubble icon.
 * Appears in bottom-right corner on settlement screens.
 */

import chatBubbleIcon from '../../assets/images/chat-bubble-icon.svg';

interface FloatingChatButtonProps {
  onClick?: () => void;
  className?: string;
}

export default function FloatingChatButton({ onClick, className = '' }: FloatingChatButtonProps) {
  return (
    <button
      onClick={onClick}
      className={`fixed bottom-6 right-6 w-14 h-14 rounded-full bg-white-alt shadow-lg border border-grey-300/50 flex items-center justify-center hover:shadow-xl hover:scale-105 transition-all z-50 ${className}`}
      aria-label="Get help"
    >
      <img src={chatBubbleIcon} alt="" className="w-10 h-10" />
    </button>
  );
}
